import React from 'react';
import { Lock } from 'lucide-react';
import { GateStatus } from '../../types/stageGate';

interface GateStatusIndicatorProps {
  gateStatus: GateStatus | undefined;
}

export const GateStatusIndicator: React.FC<GateStatusIndicatorProps> = ({ gateStatus }) => {
  if (!gateStatus?.blocked) return null;

  return (
    <div
      className="flex items-center gap-1 text-amber-600"
      title={`Stage gate blocked — ${gateStatus.missingCount} required deliverable${gateStatus.missingCount !== 1 ? 's' : ''} missing`}
    >
      <Lock className="h-3 w-3" />
      <span className="text-xs font-medium">{gateStatus.missingCount}</span>
    </div>
  );
};
